/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomSurveysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomSurveysQuery = { getCustomSurveys?: Array<{ id: number, name: string, lastUsedAt?: string | undefined, nextUsedAt?: string | undefined, theme: { id: number, name: string, color: string, icon: string } }> | undefined };


export const GetCustomSurveysDocument = gql`
    query GetCustomSurveys {
  getCustomSurveys {
    id
    name
    lastUsedAt
    nextUsedAt
    theme {
      id
      name
      color
      icon
    }
  }
}
    `;

/**
 * __useGetCustomSurveysQuery__
 *
 * To run a query within a React component, call `useGetCustomSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomSurveysQuery, GetCustomSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomSurveysQuery, GetCustomSurveysQueryVariables>(GetCustomSurveysDocument, options);
      }
export function useGetCustomSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomSurveysQuery, GetCustomSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomSurveysQuery, GetCustomSurveysQueryVariables>(GetCustomSurveysDocument, options);
        }
export type GetCustomSurveysQueryHookResult = ReturnType<typeof useGetCustomSurveysQuery>;
export type GetCustomSurveysLazyQueryHookResult = ReturnType<typeof useGetCustomSurveysLazyQuery>;
export type GetCustomSurveysQueryResult = Apollo.QueryResult<GetCustomSurveysQuery, GetCustomSurveysQueryVariables>;